import { Injectable } from '@angular/core';

import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';

import { catchError, map, tap } from 'rxjs/operators';
import { GlobalSettingsService } from '../services/ui/global-settings.service';
import { of } from 'rxjs';
import { UserContactInfo } from '../models/user-contact-info.model';
import { ProposalService } from '../services/sections/job/proposal.service';

@Injectable({
	providedIn: 'root'
})
export class ProposalRelevantContactsResolver implements Resolve<UserContactInfo[]> {
	constructor(
		private proposalService: ProposalService
	) { }

	resolve(activatedRouteSnapshot: ActivatedRouteSnapshot, routerStateSnapshot: RouterStateSnapshot) {

		GlobalSettingsService.isSecondaryLoaderLoading = true;

		return this.proposalService.getRelevantContacts(activatedRouteSnapshot.paramMap.get('token'))
			.pipe(
				catchError(() => {
					GlobalSettingsService.isSecondaryLoaderLoading = false;
					return of([] as UserContactInfo[]);
				})
			);
	}
}
